module.exports = __webpack_public_path__ + "assets/img/bp_d_i_14.7f8c4c84.jpg";